import { DeleteModalService } from './../../services/delete-modal.service';
import { DeleteModalComponent } from './../../../shared/delete-modal/delete-modal.component';
import { WarehousesModalComponent } from './../../../shared/warehouses-modal/warehouses-modal.component';
import { MasterService } from './../../services/master.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PaginationInstance } from 'ngx-pagination';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-warehouses',
  templateUrl: './warehouses.component.html',
  styleUrls: ['./warehouses.component.scss']
})
export class WarehousesComponent implements OnInit {

  public warehouses: any;
  public filter:any;
  total_count: number;
  current_page: number;
  last_page: number;
  per_page:number;
  stockPageId= 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex: number = 0;
  public searchBy: any = 0;
  public searchTxt:any;  
  placeHolder: any = 'Search By Warehouse Name';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public childMessage : string = 'listing_pagination';
  bool:boolean = false;

  //datasource: null;
  //pageIndex: number;
  //pageSize: number;
  //length: number;
  //p: number = 1;  
  //e = 1; any;  
  //public showDataTable: any;
  //public activePageDataChunk = [];
  

  constructor(public masterservice: MasterService,public dialog: MatDialog, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    this.getWarehousesData();
  }

  getWarehousesData() {
    
    //let page = e; 
    this.masterservice.getIndexGet('/warehouses').subscribe(res => {
      if (res.data && Array.isArray(res.data)) {
        this.warehouses = res.data;
        console.log('warehouses', this.warehouses.length);

        // Calculate pagination fields from array since API returns simple array
        this.per_page = 10;
        this.total_count = res.data.length;
        this.last_page = Math.ceil(this.total_count / this.per_page) || 1;
        this.current_page = 1;
        this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
        this.bool = true;

        let newData = {
          "region": "",
          "country": "",
          "location": "",
          "name": ""
        }
        
        if(this.warehouses.length < this.per_page) {
          for( var i= 0; i < this.itemToBePushed ; i++) {
            this.warehouses.push(newData);
          }
        }

        // @ts-ignore
        if(res.data.length == 0){ 
          this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
        }
      }
    })
    
  }

  getSearchValue(){
    if(this.searchBy){
      switch(this.searchBy) {
        case "0":
          this.placeHolder = 'Search By Warehouse Name';
            break;
        case "1":
          this.placeHolder = 'Search By Region Name';
            break;
        case "2":
          this.placeHolder = 'Search by Country Name';
            break;
        case "3":
          this.placeHolder = 'Search by City Name';
            break;
          default: this.placeHolder = 'Search By Warehouse Name';
      }
    }
  }

  openDialog(): void {
      const dialogRef = this.dialog.open(WarehousesModalComponent, {
      minWidth: '40vw',
      minHeight: '20vh', 
      disableClose: true
    }).afterClosed().subscribe(() => this.getWarehousesData())
  }


  editDialog(i): void {
    let editId = this.warehouses[i].id;
    let encID = this.warehouses[i].enc_id;
    console.log(editId, encID, 'id');
    
    if(editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(WarehousesModalComponent, {
        minWidth: '40vw',
        minHeight: '20vh',
        disableClose: true,
        data: {
          edit: {
            editID: editId,
            encryId: encID
          }
        }
      }).afterClosed().subscribe(() => this.getWarehousesData())
    }
     
   
  }


  selectRow(index: number) {
    console.log(index, 'selected index');
    this.selectedIndex = index;
  }

  doSearch():void{

  if(this.searchBy != null) {
      switch(this.searchBy){
         case "0":
          this.filter = { 'search': { 'type': 'str', 'field': 'warehouses.name', 'text': this.searchTxt}};
            break;
        case "1":
          this.filter = { 'search': { 'type': 'str', 'field': 'regions.name', 'text': this.searchTxt}};
            break;
        case "2":
          this.filter = {'search': { 'type': 'str', 'field': 'countries.name', 'text': this.searchTxt}};
            break;
        case "3":
          this.filter = {'search': {'type': 'str', 'field': 'locations.name', 'text': this.searchTxt}};
            break;
        default: 
        this.filter = { 'search': { 'type': 'str', 'field': 'warehouses.name', 'text': this.searchTxt}};
      }
    }       
    /*this.filter = {'search':{'type': this.searchBy.type, 'field': this.searchBy.field, 'text': this.searchTxt}};*/
    this.getWarehousesData();
  }

   doRefresh():void{   
    this.filter = this.searchTxt = null;
    this.getWarehousesData();
  }
  
  doPaginate(e):void{
    this.filter = {'page':e};
    this.getWarehousesData();
  }

  deleteDialog(i): void {
    this.deleteModalService.openModal({     
    id: this.warehouses[i]['id'],
    encId: this.warehouses[i]['enc_id'],
    deleteUrl:'/warehouses/destroy'      
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getWarehousesData();
    })
  }


}

